// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pin-number[data-v-060f6ca8] {\n  width: 229px;\n  height: 41px;\n  background-color: var(--v-secondary-25);\n}\n.phone-number[data-v-060f6ca8] {\n  width: 250px;\n}", ""]);
// Exports
module.exports = exports;
